module.exports = __webpack_public_path__ + "static/media/image6.e830f6c2.jpeg";